import { FormikProps } from "formik";
import { AccordionRoot } from "../Accordion";
import { KlientkontoerklaeringTexts } from "./texts";
import { IsCompleteHelpers } from "./util/isComplete";
import { KlientkontoerklaeringFormValues } from "../../interfaces/klientkontoerklaering";
import AESection1 from "./AdvokatensErklaering/AESection1";
import AESection2 from "./AdvokatensErklaering/AESection2";
import AESection3 from "./AdvokatensErklaering/AESection3";

export default function AdvokatensErklaering({
  texts,
  formikProps,
  isCompleteHelpers,
  locked,
}: {
  texts: KlientkontoerklaeringTexts;
  formikProps: FormikProps<KlientkontoerklaeringFormValues>;
  isCompleteHelpers: IsCompleteHelpers;
  locked?: boolean;
}) {
  return (
    <AccordionRoot
      defaultValue={["Sektion1"]}
      className={locked ? "disabled" : ""}
    >
      <AESection1 texts={texts} formikProps={formikProps} locked={locked} />
      <AESection2
        texts={texts}
        formikProps={formikProps}
        isCompleteHelpers={isCompleteHelpers}
        locked={locked}
      />
      <AESection3
        texts={texts}
        formikProps={formikProps}
        isCompleteHelpers={isCompleteHelpers}
        locked={locked}
      />
    </AccordionRoot>
  );
}
